module.exports = __webpack_public_path__ + "img/account-white.a69bba0a.svg";